import { ReadonlyURLSearchParams } from 'next/navigation'

type SearchParamOptions = {
  /**
   * Checks if the search parameter is the only one present in the URL.
   * @default false
   */
  sole?: boolean
  /**
   * Case sensitivity for the search parameter check.
   * @default false
   */
  caseSensitive?: boolean
}

/**
 *
 * @param params - The URL search parameters to check.
 * @param key - The key of the search parameter to check.
 * @param options - Options for the search parameter check.
 */
export default function hasSearchParam(
  params: ReadonlyURLSearchParams,
  key: string,
  options: SearchParamOptions = {},
) {
  const { sole = false, caseSensitive = false } = options

  if (sole && params.size !== 1) {
    return false
  }

  if (caseSensitive) {
    // Standard case-sensitive check
    return params.has(key)
  }

  // Case-insensitive check
  const paramKeys = Array.from(params.keys())

  return paramKeys.some(
    paramKey => paramKey.toLowerCase() === key.toLowerCase(),
  )
}
